import React, { useState, useEffect } from 'react';
import './Payment.css'
import { useStateValue } from "./StateProvider";
import CheckoutProduct from "./CheckoutProduct";
import { Link, useHistory } from "react-router-dom";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import CurrencyFormat from 'react-currency-format';
import { getBasketTotal } from "./reducer";
import axios from './axios';
import { db } from "./firebase";

function Payment() {

    const [{ basket, user}, dispatch] = useStateValue();
    const history = useHistory();

    const stripe = useStripe();
    const elements = useElements();
    const [succeeded, setSucceeded] = useState(false);
    const [processing, setProcessing] = useState("");
    const [error, setError] = useState(null);
    const [disabled, setDisabled] = useState(true);
    const [clientSecret, setClientSecret] = useState(true);

    useEffect(() => {
        const getClientSecret = async () => {
            const response = await axios({
                method: "post",
                url: `/payments/create?total=${getBasketTotal(basket) * 100}`
            });
            setClientSecret(response.data.clientSecret)
        }
        getClientSecret();
    }, [basket])

    console.log('the secret is', clientSecret)

    const handleSubmit = async (event) => {
        event.preventDefault();
        setProcessing(true);

        const payload = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardElement)
            }
        }).then(({paymentIntent }) => {

            db
            .collection('users')
            .doc(user?.uid)
            .collection('orders')
            .doc(paymentIntent.id)
            .set({
                basket: basket,
                amont: paymentIntent.amount,
                created: paymentIntent.created
            })

            setSucceeded(true)
            setError(true)
            setProcessing(false)

            dispatch({
                type:'EMPTY_BASKET'
            })

            history.replace(`/orders`)
        })
    }

    const handleCanged = event => {
        setDisabled(event.empty);
        setError(event.error ? event.error.message : "");
    }

    return (
        <div className="payment">
            <div className="container">
                <h1>
                    Checkout (
                        <Link to="/Checkout"> {basket?.length} items</Link>
                        )
                </h1>

                <div className="section">
                    <div className="title">
                        <h3>Delivery Address</h3>
                    </div>
                    <div className="address">
                        <p>{user?.email}</p>
                        <p>123 React Lane</p>
                        <p>Los Angeles, CA</p>
                    </div>
                </div>

                <div className="section">
                    <div className="title">
                        <h3>Review items and delivery</h3>
                    </div>
                    <div className="items">
                    {basket.map( item => (
                        <CheckoutProduct
                            id = {item.id}
                            title = {item.title}
                            image = {item.image}
                            price = {item.price}
                        />
                    ))}
                    </div>
                </div>

                <div className="section">
                    <div className="title">
                        <h3>Payment Method</h3>
                    </div>
                    <div className="details">
                        <form onSubmit={handleSubmit}>
                            <CardElement onChange={handleCanged} />

                            <div className="priceContainer">
                            <CurrencyFormat 
            renderText={(value) => (
              <h3>Order Total: {value}</h3>
            )}
                decimalScale={2}
                value={getBasketTotal(basket)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
                                />
                        <button disabled={processing || disabled || succeeded}><Link to="/order"></Link>
                            <span>{processing ? <p>Processing</p> : "Buy Now"}</span>
                        </button>
                            </div>
                            {error && <div>{error}</div>}
                        </form>
        {/* visa card number 4242 4242 4242 4242 */}
        {/* MM/YY/CVC 04 / 24 242 42424 */}
        {/* Set-ExecutionPolicy -ExecutionPolicy Bypass -Scope CurrentUser */}
                    </div>
                </div>
            </div>            
        </div>
    )
}

export default Payment
